// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__hn+KJ","header":"Page_header__WxyF+","goBack":"Page_goBack__h9HVS","title":"Page_title__enRsq","pageContent":"Page_pageContent__nu8Uh"};